"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _lodash = require("lodash");
var _components = require("@folio/stripes/components");
var _smartComponents = require("@folio/stripes/smart-components");
var _tagsConfig = require("./tagsConfig");
var _hooks = require("./hooks");
var _hooks2 = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Tags = _ref => {
  let {
    invalidateLinks = [],
    // If there are other queries that need invalidating, pass those here
    labelOverrides = {},
    link,
    onToggle,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS
  } = _ref;
  const kintIntl = (0, _hooks2.useKintIntl)(passedIntlKey, passedIntlNS);
  const ky = (0, _core.useOkapiKy)();
  const callout = (0, _react.useContext)(_core.CalloutContext);
  const queryClient = (0, _reactQuery.useQueryClient)();

  // TAG GET/POST
  const {
    data: {
      tags = []
    } = {}
  } = (0, _hooks.useTags)([..._tagsConfig.tagNamespaceArray, link]);

  // istanbul ignore next
  const {
    mutateAsync: postTags
  } = (0, _reactQuery.useMutation)(['tags', 'stripes-erm-components', 'Tags', 'postTags'], data => ky.post('tags', {
    json: data
  }).then(() => {
    queryClient.invalidateQueries('tags');
  }));

  // ENTITY GET/PUT
  const {
    data: entity
  } = (0, _reactQuery.useQuery)([link, 'stripes-erm-components', 'Tags'], () => ky.get(link).json());

  // istanbul ignore next
  const {
    mutateAsync: putEntity
  } = (0, _reactQuery.useMutation)([link, 'stripes-erm-components', 'Tags', 'putEntity'], data => ky.put(link, {
    json: data
  }).then(() => {
    queryClient.invalidateQueries(link);
    if (invalidateLinks?.length) {
      invalidateLinks.forEach(il => queryClient.invalidateQueries(il));
    }
  }));

  // add tags to global list of tags
  // istanbul ignore next
  const saveTags = tagsToSave => {
    const newTag = (0, _lodash.difference)(tagsToSave.map(t => t.value || t), tags.map(t => t.label.toLowerCase()));
    if (!newTag || !newTag.length) return;
    postTags({
      label: newTag[0],
      description: newTag[0]
    });
    callout.sendCallout({
      message: kintIntl.formatKintMessage({
        id: 'newTagCreated',
        overrideValue: labelOverrides.newTagCreated
      })
    });
  };

  // add tag to the list of entity tags
  // istanbul ignore next
  const saveEntityTags = tagsToSave => {
    const tagListMap = (entity?.tags ?? []).map(tag => ({
      'value': tag.value
    }));
    const tagsMap = tagsToSave.map(tag => ({
      'value': tag.value || tag
    }));
    const newTags = (0, _lodash.sortBy)((0, _lodash.uniqBy)([...tagListMap, ...tagsMap], 'value'));
    putEntity({
      tags: newTags
    });
  };
  const onAdd = addTags => {
    saveEntityTags(addTags);
    saveTags(addTags);
  };
  const onRemove = tag => {
    const tagToDelete = (entity?.tags ?? []).filter(t => t.value.toLowerCase() === tag.toLowerCase());
    putEntity({
      tags: [{
        id: tagToDelete[0].id,
        _delete: true
      }]
    });
  };
  const entityTags = (entity?.tags ?? []).map(tag => tag.value.toLowerCase());
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Pane, {
    defaultWidth: "20%",
    dismissible: true,
    id: "tags-helper-pane",
    onClose: onToggle,
    paneSub: kintIntl.formatKintMessage({
      id: 'numberOfTags',
      overrideValue: labelOverrides.numberOfTags
    }, {
      count: entity?.tags?.length ?? 0
    }),
    paneTitle: kintIntl.formatKintMessage({
      id: 'tags',
      overrideValue: labelOverrides.tags
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_smartComponents.TagsForm, {
      entityTags: entityTags,
      onAdd: onAdd,
      onRemove: onRemove,
      tags: tags
    })
  });
};
Tags.propTypes = {
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  invalidateLinks: _propTypes.default.arrayOf(_propTypes.default.string),
  labelOverrides: _propTypes.default.object,
  link: _propTypes.default.string,
  onToggle: _propTypes.default.func
};
var _default = exports.default = Tags;